import { Backdrop, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { fade } from '@material-ui/core/styles/colorManipulator';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: theme.palette.primary.dark,
    backgroundColor: fade(theme.palette.primary.main, 0.5),
  },
}));

export default function LoadingBackdrop(props) {
  const classes = useStyles();
  return (
    <Backdrop
      className={classes.backdrop}
      open={props.open}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
